import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { generateContentCoords } from './tooltip.helpers';
import styles from './tooltip.module.css';
import { colourString } from '../../../library';
export function Tooltip(_a) {
    var content = _a.content, children = _a.children, _b = _a.backgroundColour, backgroundColour = _b === void 0 ? 'cards' : _b, _c = _a.borderColour, borderColour = _c === void 0 ? 'secondary' : _c, _d = _a.colour, colour = _d === void 0 ? 'text' : _d, _e = _a.fontWeight, fontWeight = _e === void 0 ? '400' : _e, _f = _a.textTransform, textTransform = _f === void 0 ? 'none' : _f;
    var contentRef = useRef(null);
    var _g = useState(), event = _g[0], setEvent = _g[1];
    var _h = useState({ left: 0, top: 0 }), contentCoords = _h[0], setContentCoords = _h[1];
    useEffect(function () {
        window.addEventListener('scroll', hideTooltipContent);
        window.addEventListener('click', hideTooltipContent);
        if (!event) {
            hideTooltipContent();
            return;
        }
        showTooltipContent();
        return function () {
            window.removeEventListener('scroll', hideTooltipContent);
            window.removeEventListener('click', hideTooltipContent);
        };
    }, [event]);
    function showTooltipContent() {
        var contentElement = contentRef.current;
        if (!event || !contentElement)
            return setEvent(undefined);
        setContentCoords(generateContentCoords(event, contentElement));
        setEvent(event);
    }
    function hideTooltipContent() {
        setEvent(undefined);
        setTimeout(function () { return setEvent(undefined); });
    }
    return (React.createElement("div", { className: classNames("kplr_tooltip", styles.tooltipContainer) },
        React.createElement("div", { className: classNames(styles.tooltipAnchor), onMouseEnter: function (event) { return setEvent(event); }, onMouseLeave: function () { return setEvent(undefined); }, onTouchStart: function (event) {
                var touch = event.nativeEvent.touches[0] || event.nativeEvent.changedTouches[0];
                setEvent({ clientX: touch.pageX, clientY: touch.pageY });
            } }, children),
        !!event && ReactDOM.createPortal(React.createElement("div", { ref: contentRef, className: classNames(styles.tooltipContent), style: {
                left: "".concat(contentCoords.left, "px"),
                top: "".concat(contentCoords.top, "px"),
                backgroundColor: colourString(backgroundColour),
                borderColor: colourString(borderColour),
            } },
            React.createElement("span", { className: "caption1", style: { color: colourString(colour), textTransform: textTransform, fontWeight: fontWeight } }, content)), window.document.body)));
}
export default Tooltip;
